import React from "react";
import Bg from "../Bg";
import styled, { css, ThemeProvider } from "styled-components";
import { themes, themeSecure } from '../../defaults';
import Colorer from "color";
import { InputM } from "../uikit-b2c/InputM";
import { ContentBlock } from "../uikit-b2c/uikit-b2c";
import { PSmethods, CSSoneMethod, CSSsvgMethod } from './PSmethods';
import { methods } from '../uikit-b2c/methods';
import { Svg } from '../uikit-b2c/Svg';

export function MethodCard1({ theme = themes[0] }) {
  return (
    <ThemeProvider theme={theme}>
      <ContentBlock>
        <div style={{ width: "100%" }}>
          <div className="xsbps_cardblock">
            <div className="xsbps_form w-form">
              <form
                id="wf-form-xsbps_form"
                name="wf-form-xsbps_form"
                data-name="xsbps_form"
              >
                <div
                  style={{
                    paddingTop: 8,
                    display: "grid",
                    gridTemplateColumns: "68% 1fr",
                    gridColumnGap: 28,
                  }}
                >
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gridColumnGap: 16,
                      gridRowGap: 16,
                    }}
                  >
                    <div style={{ gridColumn: "1/3" }}>

                      <InputM
                        theme={themeSecure}
                        style={{ width: "100%", minWidth: 184 }}
                        value=""
                        size="sm"
                        monospace
                        handle={() => void 0}
                        label="Card number"
                        placeholder={"0000 0000 0000 0000"}
                        autofocus={true}
                      />
                    </div>


                    <div className="xsbps_input-block">
                      <div
                        className="xsbps_input-title"
                        style={{
                          width: 160,
                          flexGrow: 0,
                        }}
                      >
                        <div className="xsbps_input-block">
                          <InputM
                            theme={themeSecure}
                            value=""
                            size="sm"
                            monospace
                            handle={() => void 0}
                            label="Expiration"
                            placeholder={"01/20"}
                            autofocus={false}
                          />

                        </div>
                      </div>
                    </div>
                    <div className="xsbps_input-title">
                      <InputM
                        theme={themeSecure}
                        value=""
                        size="sm"
                        monospace
                        handle={() => void 0}
                        label="Zip-Code"
                        placeholder={"00000"}
                        autofocus={false}
                      />
                    </div>


                    <div style={{
                      gridColumn: "1/3",
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-end',
                     }}>

                        {<Svg
                          height={18}
                          style={{marginLeft: 12}}
                        >
                          {methods['method_visa']["icon"]}
                        </Svg>}



                    </div>

                  </div>

                  <div className="xsbps_input-cvv" style={{ paddingTop: 58 }}>
                    {/* <label htmlFor="Cvv-3" className="xsbps_input-title">
                    CVV2/CVC2
                  </label> */}
                    <InputM
                      theme={themeSecure}
                      value=""
                      size="sm"
                      monospace
                      handle={() => void 0}
                      label="CVV2/CVC2"
                      placeholder={"***"}
                      autofocus={false}
                    />

                  </div>
                </div>
              </form>
              <div className="w-form-done">
                <div>Thank you! Your submission has been received!</div>
              </div>
              <div className="w-form-fail">
                <div>Oops! Something went wrong while submitting the form.</div>
              </div>
            </div>
            <div
              className="xsbps_cardblock_bg"
              style={{
                opacity: 1,
              }}
            >
              <div
                className="xsbps_cardblock_card"
                style={{
                  width: "72%",
                  opacity: 1,
                  boxShadow: "none",
                  borderRadius: 10,
                  overflow: "hidden",
                  boxShadow: `0px 4px 16px -4px ${Colorer(theme["colorAccent"])
                    .darken(0.9)
                    .alpha(0.3)
                    .string()}`,
                }}
              >
                <div
                  className="xsbps_card_bg"
                  style={{
                    opacity: 1,
                    background: Colorer(theme["colorAccent"])
                      .lighten(0.4)
                      .string(),
                  }}
                />
              </div>
              <div
                className="xsbps_cardblock_card xsbps_cardblock_card_cvv"
                style={{
                  width: "72%",
                  opacity: 0.8,
                  boxShadow: "none",
                  borderRadius: 10,
                  overflow: "hidden",
                  // boxShadow: "0px 8px 12px -4px rgba(0,0,0,0.4)"
                }}
              >
                <div
                  className="xsbps_card_bg"
                  style={{
                    opacity: 0.4,
                    backgroundColor: '#FFFFFF',
                  //   background: Colorer(theme["colorAccent"])
                  //     .lighten(0.2)
                  //     .string(),
                  }}
                >
                  <div
                    className="xbm_accentbg xbm_accentbg--default"
                    style={{
                      background: theme["colorAccent"],
                      borderRadius: 12,
                      // boxShadow: "0px 8px 4px 0 rgba(0,0,0,0.4)"
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </ContentBlock>
    </ThemeProvider>
  );
}
